"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.Paragraph = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.Mark = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _color = _interopRequireDefault(require("../../constants/color"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _titleGenerator = _interopRequireDefault(require("../helpers/title-generator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Mark = function Mark(_ref) {
  var children = _ref.children,
      light = _ref.light;
  return _react.default.createElement("mark", {
    className: light ? 'co--light' : null
  }, children);
};

exports.Mark = Mark;

var HeadingStyler = function HeadingStyler(_ref2) {
  var children = _ref2.children,
      level = _ref2.level,
      truncated = _ref2.truncated,
      asH1 = _ref2.asH1,
      asH2 = _ref2.asH2,
      asH3 = _ref2.asH3,
      asH4 = _ref2.asH4,
      asH5 = _ref2.asH5,
      asH6 = _ref2.asH6,
      props = _objectWithoutProperties(_ref2, ["children", "level", "truncated", "asH1", "asH2", "asH3", "asH4", "asH5", "asH6"]);

  var allowedProps = {
    truncated: truncated
  };
  var title = truncated ? (0, _titleGenerator.default)(props.title, children) : null;
  var tag = 'h' + level;
  var headingClasses = {
    'co-heading': true,
    'co-heading--1': asH1,
    'co-heading--2': asH2,
    'co-heading--3': asH3,
    'co-heading--4': asH4,
    'co-heading--5': asH5,
    'co-heading--6': asH6
  };
  delete headingClasses['co-heading--' + level];
  return _react.default.createElement(_styler.default, {
    classNames: headingClasses,
    modifiers: allowedProps
  }, function (styles) {
    var className = styles || null;

    var headingElement = _react.default.createElement(tag, _objectSpread({
      className: className,
      title: title
    }, (0, _getNativeProps.default)(props)), children);

    return headingElement;
  });
};

var H1 = function H1(props) {
  return _react.default.createElement(HeadingStyler, _extends({}, props, {
    level: 1
  }));
};

exports.H1 = H1;

var H2 = function H2(props) {
  return _react.default.createElement(HeadingStyler, _extends({}, props, {
    level: 2
  }));
};

exports.H2 = H2;

var H3 = function H3(props) {
  return _react.default.createElement(HeadingStyler, _extends({}, props, {
    level: 3
  }));
};

exports.H3 = H3;

var H4 = function H4(props) {
  return _react.default.createElement(HeadingStyler, _extends({}, props, {
    level: 4
  }));
};

exports.H4 = H4;

var H5 = function H5(props) {
  return _react.default.createElement(HeadingStyler, _extends({}, props, {
    level: 5
  }));
};

exports.H5 = H5;

var H6 = function H6(props) {
  return _react.default.createElement(HeadingStyler, _extends({}, props, {
    level: 6
  }));
};

exports.H6 = H6;

var Paragraph = function Paragraph(_ref3) {
  var children = _ref3.children,
      color = _ref3.color,
      truncated = _ref3.truncated,
      microcopy = _ref3.microcopy,
      forceLineBreak = _ref3.forceLineBreak,
      title = _ref3.title,
      props = _objectWithoutProperties(_ref3, ["children", "color", "truncated", "microcopy", "forceLineBreak", "title"]);

  var allowedProps = {
    truncated: truncated,
    microcopy: microcopy,
    forceLineBreak: forceLineBreak
  };

  var paragraphClasses = _defineProperty({}, color, color);

  return _react.default.createElement(_styler.default, {
    classNames: paragraphClasses,
    modifiers: allowedProps
  }, function (styles) {
    return _react.default.createElement("p", _extends({
      className: styles,
      title: truncated ? (0, _titleGenerator.default)(title, children) : null
    }, (0, _getNativeProps.default)(props)), children);
  });
};

exports.Paragraph = Paragraph;
Paragraph.COLOR = {
  GRAY_600: _color.default.gray[600]
};

var Text = function Text(_ref4) {
  var children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["children"]);

  return _react.default.createElement(_styler.default, {
    modifiers: props
  }, function (styles) {
    return _react.default.createElement("span", _extends({
      className: styles
    }, (0, _getNativeProps.default)(props)), children);
  });
};

exports.Text = Text;
var textModifiers = ['truncated', 'forceLineBreak'];

function headingExclusiveTrueProps(index) {
  var headingProps = ['asH1', 'asH2', 'asH3', 'asH4', 'asH5', 'asH6'];
  headingProps.splice(index, 1);
  return _airbnbPropTypes.mutuallyExclusiveTrueProps.apply(void 0, headingProps);
}

var headingProptypes = {
  children: _propTypes.node.isRequired,
  truncated: _propTypes.bool,
  title: _propTypes.string
};
var H1ExclusiveProps = headingExclusiveTrueProps(0);
var H2ExclusiveProps = headingExclusiveTrueProps(1);
var H3ExclusiveProps = headingExclusiveTrueProps(2);
var H4ExclusiveProps = headingExclusiveTrueProps(3);
var H5ExclusiveProps = headingExclusiveTrueProps(4);
var H6ExclusiveProps = headingExclusiveTrueProps(5);
H1.propTypes = _objectSpread({}, headingProptypes, {
  asH2: H1ExclusiveProps,
  asH3: H1ExclusiveProps,
  asH4: H1ExclusiveProps,
  asH5: H1ExclusiveProps,
  asH6: H1ExclusiveProps
});
H2.propTypes = _objectSpread({}, headingProptypes, {
  asH1: H2ExclusiveProps,
  asH3: H2ExclusiveProps,
  asH4: H2ExclusiveProps,
  asH5: H2ExclusiveProps,
  asH6: H2ExclusiveProps
});
H3.propTypes = _objectSpread({}, headingProptypes, {
  asH1: H3ExclusiveProps,
  asH2: H3ExclusiveProps,
  asH4: H3ExclusiveProps,
  asH5: H3ExclusiveProps,
  asH6: H3ExclusiveProps
});
H4.propTypes = _objectSpread({}, headingProptypes, {
  asH1: H4ExclusiveProps,
  asH2: H4ExclusiveProps,
  asH3: H4ExclusiveProps,
  asH5: H4ExclusiveProps,
  asH6: H4ExclusiveProps
});
H5.propTypes = _objectSpread({}, headingProptypes, {
  asH1: H5ExclusiveProps,
  asH2: H5ExclusiveProps,
  asH3: H5ExclusiveProps,
  asH4: H5ExclusiveProps,
  asH6: H5ExclusiveProps
});
H6.propTypes = _objectSpread({}, headingProptypes, {
  asH1: H6ExclusiveProps,
  asH2: H6ExclusiveProps,
  asH3: H6ExclusiveProps,
  asH4: H6ExclusiveProps,
  asH5: H6ExclusiveProps
});
Paragraph.propTypes = {
  children: _propTypes.any.isRequired,

  /** {const} Only accepts Color.gray[600] */
  color: (0, _propTypes.oneOf)([_color.default.gray[600]]),

  /** {bool} Mutually exclusive props: @@truncated@@ @@forceLineBreak@@; Required if @@title@@ is defined. */
  truncated: (0, _airbnbPropTypes.requiredBy)('title', _propTypes.bool),
  title: _propTypes.string,
  microcopy: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@truncated@@ @@forceLineBreak@@ */
  forceLineBreak: _airbnbPropTypes.mutuallyExclusiveTrueProps.apply(void 0, textModifiers)
};
Text.propTypes = {
  children: _propTypes.node.isRequired,
  truncated: _airbnbPropTypes.mutuallyExclusiveTrueProps.apply(void 0, textModifiers),
  microcopy: _propTypes.bool,
  forceLineBreak: _airbnbPropTypes.mutuallyExclusiveTrueProps.apply(void 0, textModifiers)
};
Mark.propTypes = {
  children: _propTypes.string.isRequired,
  light: _propTypes.bool
};
Mark.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Mark",
  "props": {
    "children": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "light": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};
H1.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "H1",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "truncated": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "asH2": {
      "type": {
        "name": "custom",
        "raw": "H1ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH3": {
      "type": {
        "name": "custom",
        "raw": "H1ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH4": {
      "type": {
        "name": "custom",
        "raw": "H1ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH5": {
      "type": {
        "name": "custom",
        "raw": "H1ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH6": {
      "type": {
        "name": "custom",
        "raw": "H1ExclusiveProps"
      },
      "required": false,
      "description": ""
    }
  }
};
H2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "H2",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "truncated": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "asH1": {
      "type": {
        "name": "custom",
        "raw": "H2ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH3": {
      "type": {
        "name": "custom",
        "raw": "H2ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH4": {
      "type": {
        "name": "custom",
        "raw": "H2ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH5": {
      "type": {
        "name": "custom",
        "raw": "H2ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH6": {
      "type": {
        "name": "custom",
        "raw": "H2ExclusiveProps"
      },
      "required": false,
      "description": ""
    }
  }
};
H3.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "H3",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "truncated": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "asH1": {
      "type": {
        "name": "custom",
        "raw": "H3ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH2": {
      "type": {
        "name": "custom",
        "raw": "H3ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH4": {
      "type": {
        "name": "custom",
        "raw": "H3ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH5": {
      "type": {
        "name": "custom",
        "raw": "H3ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH6": {
      "type": {
        "name": "custom",
        "raw": "H3ExclusiveProps"
      },
      "required": false,
      "description": ""
    }
  }
};
H4.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "H4",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "truncated": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "asH1": {
      "type": {
        "name": "custom",
        "raw": "H4ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH2": {
      "type": {
        "name": "custom",
        "raw": "H4ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH3": {
      "type": {
        "name": "custom",
        "raw": "H4ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH5": {
      "type": {
        "name": "custom",
        "raw": "H4ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH6": {
      "type": {
        "name": "custom",
        "raw": "H4ExclusiveProps"
      },
      "required": false,
      "description": ""
    }
  }
};
H5.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "H5",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "truncated": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "asH1": {
      "type": {
        "name": "custom",
        "raw": "H5ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH2": {
      "type": {
        "name": "custom",
        "raw": "H5ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH3": {
      "type": {
        "name": "custom",
        "raw": "H5ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH4": {
      "type": {
        "name": "custom",
        "raw": "H5ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH6": {
      "type": {
        "name": "custom",
        "raw": "H5ExclusiveProps"
      },
      "required": false,
      "description": ""
    }
  }
};
H6.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "H6",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "truncated": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "asH1": {
      "type": {
        "name": "custom",
        "raw": "H6ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH2": {
      "type": {
        "name": "custom",
        "raw": "H6ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH3": {
      "type": {
        "name": "custom",
        "raw": "H6ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH4": {
      "type": {
        "name": "custom",
        "raw": "H6ExclusiveProps"
      },
      "required": false,
      "description": ""
    },
    "asH5": {
      "type": {
        "name": "custom",
        "raw": "H6ExclusiveProps"
      },
      "required": false,
      "description": ""
    }
  }
};
Paragraph.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Paragraph",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "color": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "Color.gray[600]",
          "computed": true
        }]
      },
      "required": false,
      "description": "{const} Only accepts Color.gray[600]"
    },
    "truncated": {
      "type": {
        "name": "custom",
        "raw": "requiredBy('title', bool)"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@truncated@@ @@forceLineBreak@@; Required if @@title@@ is defined."
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "microcopy": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "forceLineBreak": {
      "type": {
        "name": "custom",
        "raw": "mutuallyExclusiveTrueProps(...textModifiers)"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@truncated@@ @@forceLineBreak@@"
    }
  }
};
Text.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Text",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "truncated": {
      "type": {
        "name": "custom",
        "raw": "mutuallyExclusiveTrueProps(...textModifiers)"
      },
      "required": false,
      "description": ""
    },
    "microcopy": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "forceLineBreak": {
      "type": {
        "name": "custom",
        "raw": "mutuallyExclusiveTrueProps(...textModifiers)"
      },
      "required": false,
      "description": ""
    }
  }
};